import apiClient from './api';

export type ContentField = 'title' | 'description' | 'summary' | 'plusinfo' | 'youtube';

export interface ContentFieldResponse {
  [key: string]: string;
}

export const contentService = {
  /**
   * Get a specific content field for a marker and language (public read-only)
   */
  getContentField: async (
    markerId: string,
    language: string,
    field: ContentField
  ): Promise<ContentFieldResponse> => {
    const response = await apiClient.get<ContentFieldResponse>(
      `/api/content/${markerId}/${language}/${field}`
    );
    return response.data;
  },

  /**
   * Update is not available in public frontend (read-only)
   * This is a stub to prevent errors when MarkerCluster checks for the method
   */
  updateContentField: async (_markerId: string, _language: string, _field: ContentField, _value: string): Promise<never> => {
    throw new Error('Update operations are not available in public frontend');
  },
};

